<app-view-dashboard-component>
  <div modalTitle>
    {{ 'nav.sales' | translate }}
  </div>
  <div class="ion-margin-top">
    <ion-item lines="none"
      button="true"
      (click)="onLive()">
      <ion-icon slot="start"
        name="people-outline"></ion-icon>
      {{ 'partner.salesLive' | translate }}
    </ion-item>
  </div>
  <h4>{{ 'partner.stats' | translate }}</h4>
  <app-snap-links [items]="snapLinks$ | async"></app-snap-links>
  @if (clientsChart$ | async) { }
  <canvas id="clientsChart"></canvas>
  @if (licensesChart$ | async) { }
  <canvas id="licensesChart"></canvas>
</app-view-dashboard-component>